<template>
    <div>
        <page-title>{{ title }}</page-title>
        <company-route-tabs
            v-if="isSuperAdmin"
            :company-id="companyId"
        ></company-route-tabs>
        <company-allowed-meals-table :company-id="companyId">
            <template v-slot:actions>
                <create-button
                    :route-name="routeType.COMPANY_ALLOWED_MEAL_CREATE"
                    tabbed
                ></create-button>
            </template>
        </company-allowed-meals-table>
    </div>
</template>

<script>
import routeType from '@/router/routeType'
import SelectApiClienType from '@/api/SelectApiClientType'
import TitleMixinGenerator from '@/components/mixins/page-title/TitleMixinGenerator'
import AuthMixin from '@/components/mixins/AuthMixin'
import CreateButton from '@/components/form/Actions/CreateButton'
import CompanyRouteTabs from '@/components/pages/companies/RouteTabs'
import CompanyAllowedMealsTable from '@/components/pages/companyAllowedMeals/Table'

export default {
    components: {
        CreateButton,
        CompanyRouteTabs,
        CompanyAllowedMealsTable,
    },
    mixins: [
        TitleMixinGenerator(SelectApiClienType.COMPANY, 'companyId'),
        AuthMixin,
    ],
    props: {
        companyId: {
            type: [String, Number],
            default: null,
        },
    },
    data() {
        return {
            routeType,
        }
    },
}
</script>
